import { render, staticRenderFns } from "./historicoInventario.vue?vue&type=template&id=329d1665"
import script from "./historicoInventario.vue?vue&type=script&lang=js"
export * from "./historicoInventario.vue?vue&type=script&lang=js"
import style0 from "./historicoInventario.vue?vue&type=style&index=0&id=329d1665&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports